import { render, staticRenderFns } from "./Facturacion.vue?vue&type=template&id=4d7b740b&"
import script from "./Facturacion.vue?vue&type=script&lang=js&"
export * from "./Facturacion.vue?vue&type=script&lang=js&"
import style0 from "./Facturacion.vue?vue&type=style&index=0&id=4d7b740b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports